import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Class-name merger. We tried dropping tailwind-merge to save
 * ~19 KB minified from the entry chunk; visual diff against the
 * live site found the home-page CTAs (Fixadores / Ferramentas /
 * Serviços, plus several Button-variant call sites) flipped
 * background colors because cva's variant defaults were being
 * appended after the caller's `className` override and clsx-only
 * concatenation let CSS source order favour the variant default
 * over the override. tailwind-merge's intelligent conflict
 * resolution is the only thing keeping those call sites correct
 * — keeping it. See PERF-NIGHT-2026-05-05.md for the audit trail.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
